import moment from "moment-timezone";

export function formatDate(value: any) {
  const options: any = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  if (typeof value !== "string" || value.trim() === "" || value === null) {
    return "";
  } else {
    const nDate = new Date(value);
    return nDate.toLocaleDateString("es", options);
  }
}

export function formatDateTime(value: any) {
  const options: any = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  if (typeof value != "string" || value.trim() === "" || value === null) {
    return "";
  } else {
    const nDate = new Date(value);
    return nDate.toLocaleDateString("es", options);
  }
}

export function fixTimeFormat(value: any) {
  if (Number(value) < 10) {
    return "0" + value;
  }
  return value;
}

export function getHHMM(value: any) {
  const date = new Date(value);
  const hours = fixTimeFormat(date.getHours());
  const minutes = fixTimeFormat(date.getMinutes());

  return `${hours}:${minutes}`;
}

// Receives three positive integers.
export function isValidDate(day: any, month: any, year: any) {
  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (isLeap(year)) {
    daysInMonth[1] = 29;
  }
  return day > 0 && day <= daysInMonth[month - 1];
}

// Receives a positive integer.
export function isLeap(year: any) {
  if (year % 4 === 0) {
    if (year % 100 === 0) {
      if (year % 400 === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  } else {
    return false;
  }
}

// Receives string with format "dd/mm/yyyy".
// Returns the date with format "yyyy-mm-dd".
export function dateToISO(date: any) {
  return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
}

// Receives string date with format "dd/mm/yyyy".
// Receives integer days.
// Returns the date with format "dd/mm/yyyy".
export function addDaysToDate(date: any, days: any) {
  return moment(date, "DD-MM-YYYY").add(days, "days").format("DD-MM-YYYY");
}

export function subtractDaysToDate(date: any, days: any) {
  return moment(date, "DD-MM-YYYY").subtract(days, "days").format("DD-MM-YYYY");
}

export function dateToRegularFormat(date: any) {
  // String.replaceAll is not widely available.
  return moment(date).format("DD-MM-YYYY").replace("-", "/").replace("-", "/");
}

export function getTodayDate() {
  return new Date(new Date().setHours(0, 0, 0, 0));
}
